import { render, staticRenderFns } from "./infocard.vue?vue&type=template&id=860ad494&scoped=true&"
import script from "./infocard.vue?vue&type=script&lang=js&"
export * from "./infocard.vue?vue&type=script&lang=js&"
import style0 from "./infocard.vue?vue&type=style&index=0&id=860ad494&prod&lang=scss&"
import style1 from "./infocard.vue?vue&type=style&index=1&id=860ad494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860ad494",
  null
  
)

export default component.exports